import { Box, Title } from "@mantine/core";
import { useId, type AriaRole, type ReactNode } from "react";
import classes from "./index.module.css";

type GateNoticeCardProps = {
  /** Ícone da moldura (Tabler, 18px). */
  icon: ReactNode;
  eyebrow: string;
  /** Título que diz o fato; também é o nome acessível do card. */
  title: string;
  /** Texto de apoio abaixo do título. */
  body: ReactNode;
  /** O que vem depois do texto (linha de administradores, ação). */
  children?: ReactNode;
  /** Ex.: "alert" quando o card aparece no lugar de um carregamento. */
  role?: AriaRole;
};

/**
 * Card de aviso dos gates que fica no FLUXO da página (aviso de administrador
 * da conexão do WhatsApp, erro ao carregar permissões). Mesmo vocabulário do
 * card do bloqueio de recurso (FeatureGate): moldura do ícone, eyebrow, título
 * que diz o fato. No fluxo, é card com borda e sem sombra.
 */
export function GateNoticeCard({
  icon,
  eyebrow,
  title,
  body,
  children,
  role,
}: GateNoticeCardProps) {
  const titleId = useId();

  return (
    <Box
      component="section"
      role={role}
      aria-labelledby={titleId}
      className={classes.root}>
      <Box className={classes.header}>
        <Box
          component="span"
          className={classes.iconFrame}>
          {icon}
        </Box>
        <Box
          component="span"
          className={classes.eyebrow}>
          {eyebrow}
        </Box>
      </Box>
      <Title
        order={2}
        id={titleId}
        fz="var(--sa-fs-dialog-title)"
        lh="var(--sa-lh-tight)"
        className={classes.title}>
        {title}
      </Title>
      <Box
        component="p"
        className={classes.body}>
        {body}
      </Box>
      {children}
    </Box>
  );
}

export default GateNoticeCard;
